module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    ref: "orderdetails",
    staticClass: "orderdetails"
  }, [_c('div', {
    staticClass: "rating-wrapper"
  }, [_c('ul', [_c('li', {
    staticClass: "food border-1px"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('pre', [_vm._v(_vm._s(_vm.$t('productname')))])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('pre', [_vm._v(_vm._s(_vm.$t('cont')))])])]), _vm._v(" "), _vm._l((_vm.orderdetailsobj), function(item) {
    return _c('li', {
      staticClass: "food border-1px"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.ProductName))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('span', [_vm._v(_vm._s(item.Quantity) + " x " + _vm._s(item.UnitPrice) + " €")])])])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f82f958","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/orderdetails.vue
// module id = 477
// module chunks = 1